import { Container } from 'pixi.js';
import { applyLayoutState } from 'libs/layouts/populateLayouts/applyLayoutState';
import { PiggyBankSmallLayout } from '../../../../layouts/piggybank/PiggyBankSmallLayout';
import type { PiggyBankTier } from '../types';

export enum PiggyBankMood {
  Normal = 'Normal',
  Happy = 'Happy',
  Sorry = 'Sorry',
}

export class PiggyBankMoodView extends Container {
  private readonly layout = new PiggyBankSmallLayout();

  constructor() {
    super();

    this.addChild(this.layout.root);
    this.setIconState(PiggyBankMood.Normal);
  }

  public setIconState(state: PiggyBankMood): void {
    const { pigNormal, pigHappy, pigSorry } = this.layout;

    pigNormal.props({
      visible: state === PiggyBankMood.Normal,
    });

    pigHappy.props({
      visible: state === PiggyBankMood.Happy,
    });

    pigSorry.props({
      visible: state === PiggyBankMood.Sorry,
    });
  }

  public setTier(tier: PiggyBankTier): void {
    applyLayoutState(this.layout, tier);
  }
}
